<template>
  <div>
    <b-table
      :items="records"
      :fields="fields"
      :busy="isLoaging"
      class="col-12 mt-2 table-views"
      show-empty
    >
      <template #empty>
        <div class="text-center my-2">
          <h3>No hay eventos registrados</h3>
        </div>
      </template>

      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <overlay-button></overlay-button>
        </div>
      </template>
      <template #cell(options)="row">
        <button
          class="button-table-employee"
          :id="`tooltip-button-ver-${row.item?.id}`"
          @click.prevent="findItem(row.item?.id)"
        >
          <img
            class="centerImg1 resaltar"
            :src="require('@/assets/images/icons/eye-line.svg')"
          />
        </button>

        <b-tooltip
          :target="`tooltip-button-ver-${row.item.id}`"
          placement="top"
          custom-class="custom-tooltip-ht"
        >
          Ver Detalle
        </b-tooltip>
      </template>
    </b-table>
  </div>
</template>

<script>
import Pagination from "laravel-vue-pagination";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
export default {
  components: {
    Pagination,
    OverlayButton,
  },
  data() {
    return {
      fields: [
        {
          label: "Evento registrado / Código",
          key: "worker",
        },
        {
          label: "Diagnostico",
          key: "diagnostic",
        },
        {
          label: "Fecha y hora del evento",
          key: "doctor_name",
        },
        {
          label: "Nombre / C.C",
          key: "created_at",
        },
        {
          label: "Sharp ID",
          key: "created_at",
        },
        {
          label: "Cargo",
          key: "created_at",
        },
        {
          label: "Estado",
          key: "created_at",
        },
        {
          label: "Etapa",
          key: "created_at",
        },
        {
          label: "",
          key: "options",
        },
      ],
      isLoaging: false,
      records: [],
      id: this.$route.params.type
    };
  },
  watch: {},
  methods: {
    findItem(id) {
      // const me = this;
      console.log(id)
      // me.$router.push({
      //   name: "DetailExamenPage",
      //   params: { category: "salud-condition", type: me.$route.params.type, id: id },
      // });
    },
    
  },
  mounted() {}
};
</script>

<style lang="css">
.custom-tooltip-ht .tooltip-inner {
  max-width: 200px !important;
  background-color: #263238 !important;
  font-size: 14px !important;
}
.text-file {
  color: #1719da80;
  font-size: 16px;
  cursor: pointer;
}
.list-diagnostic {
  list-style: disc !important;
  padding: 0 !important;
}
.list-diagnostic li {
  overflow: hidden;
  width: 250px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
